import React, { FC } from "react";
import { Svg, Mask, Rect, G, SvgProps } from "react-native-svg";

export type CentralIconBaseProps = {
  size?: string | number;
  mode?: "masked" | "raw";
  maskId?: string;
} & SvgProps;

export const CentralIconBase: FC<CentralIconBaseProps> = ({
  children,
  size = 24,
  mode = "masked",
  maskId,
  ...props
}) => {
  const masked = mode !== "raw" && !!maskId;
  return (
    <Svg
      {...props}
      width={typeof size === "number" ? `${size}px` : size}
      height={typeof size === "number" ? `${size}px` : size}
      viewBox="0 0 24 24"
      fill="none"
    >
      {masked ? (
        <>
          <Mask
            id={maskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <Rect width="24" height="24" fill="#000" />
            <G color="#fff">{children}</G>
          </Mask>
          <Rect
            width="24"
            height="24"
            fill="currentColor"
            mask={`url(#${maskId})`}
          />
        </>
      ) : (
        children
      )}
    </Svg>
  );
};
